import React from "react";
import { Grid, Typography, TextField } from "@mui/material";

const MqSettings = ({ formik, setTouched }) => {
  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };

  return (
    <Grid
      container
      justifyContent="start"
      alignItems="center"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "30px",
      }}
    >
      <Grid item xs={12}>
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
            lineHeight: "21px",
            marginBottom: "20px",
          }}
        >
          MQ Settings
        </Typography>
      </Grid>

      <Grid item container xs={10} rowSpacing={2} columnSpacing={2}>
        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            MQ Manager
          </Typography>
          <TextField
            name="MQManager"
            value={formik.values.MQManager}
            onChange={handleChange}
            error={formik.touched.MQManager && Boolean(formik.errors.MQManager)}
            helperText={formik.touched.MQManager && formik.errors.MQManager}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.MQManager && { marginBottom: "10px" }),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            MQ Server
          </Typography>
          <TextField
            name="MQServer"
            value={formik.values.MQServer}
            onChange={handleChange}
            error={formik.touched.MQServer && Boolean(formik.errors.MQServer)}
            helperText={formik.touched.MQServer && formik.errors.MQServer}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.MQServer && { marginBottom: "10px" }),
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Q In
          </Typography>
          <TextField
            name="QIn"
            value={formik.values.QIn}
            onChange={handleChange}
            error={formik.touched.QIn && Boolean(formik.errors.QIn)}
            helperText={formik.touched.QIn && formik.errors.QIn}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.QIn && { marginBottom: "10px" }),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Q Out
          </Typography>
          <TextField
            name="QOut"
            value={formik.values.QOut}
            onChange={handleChange}
            error={formik.touched.QOut && Boolean(formik.errors.QOut)}
            helperText={formik.touched.QOut && formik.errors.QOut}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.QOut && { marginBottom: "10px" }),
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Q To Swift
          </Typography>
          <TextField
            name="QToSwift"
            value={formik.values.QToSwift}
            onChange={handleChange}
            error={formik.touched.QToSwift && Boolean(formik.errors.QToSwift)}
            helperText={formik.touched.QToSwift && formik.errors.QToSwift}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.QToSwift && { marginBottom: "10px" }),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Port
          </Typography>
          <TextField
            name="QToSwift"
            value={formik.values.port}
            onChange={handleChange}
            error={formik.touched.port && Boolean(formik.errors.port)}
            helperText={formik.touched.port && formik.errors.port}
            sx={{
              width: "100%",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.port && { marginBottom: "10px" }),
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MqSettings;
